export class StringModel {
    public word: string;

    constructor( word: string ) {
        this.word = word;
    }
}

